import { SELECTORS, KEYS, SWIPER } from '../utils/constants';

// Shows one panel and marks its tab selected. A Swiper initialised inside a
// hidden panel measured zero width, so it is re-measured once visible.
const activateTab = (tabEls, panelEls, activeIndex, shouldFocus) => {
  tabEls.forEach((tabEl, index) => {
    const isActive = index === activeIndex;
    tabEl.setAttribute('aria-selected', String(isActive));
    tabEl.setAttribute('tabindex', isActive ? '0' : '-1');
    if (isActive && shouldFocus) tabEl.focus();
  });

  panelEls.forEach((panelEl, index) => {
    const isActive = index === activeIndex;
    panelEl.hidden = !isActive;
    if (!isActive) return;
    const swiperEl = panelEl.querySelector(SWIPER.CONTAINER_CLASS);
    if (swiperEl && swiperEl.swiper) swiperEl.swiper.update();
  });
};

const getNextTabIndex = (key, currentIndex, lastIndex) => {
  switch (key) {
    case KEYS.ARROW_RIGHT:
      return currentIndex === lastIndex ? 0 : currentIndex + 1;
    case KEYS.ARROW_LEFT:
      return currentIndex === 0 ? lastIndex : currentIndex - 1;
    case KEYS.HOME:
      return 0;
    case KEYS.END:
      return lastIndex;
    default:
      return -1;
  }
};

const initTabGroup = (tabGroupEl) => {
  const tabEls = [...tabGroupEl.querySelectorAll(SELECTORS.TAB)];
  const panelEls = [...tabGroupEl.querySelectorAll(SELECTORS.TAB_PANEL)];
  if (!tabEls.length || tabEls.length !== panelEls.length) return;

  tabEls.forEach((tabEl, index) => {
    tabEl.addEventListener('click', () => activateTab(tabEls, panelEls, index, false));
  });

  tabGroupEl.addEventListener('keydown', (event) => {
    const currentIndex = tabEls.indexOf(event.target);
    if (currentIndex === -1) return;
    const nextIndex = getNextTabIndex(event.key, currentIndex, tabEls.length - 1);
    if (nextIndex === -1) return;
    event.preventDefault();
    activateTab(tabEls, panelEls, nextIndex, true);
  });
};

const initTabs = () => {
  const tabGroupEls = document.querySelectorAll(SELECTORS.TABS);
  if (!tabGroupEls.length) return;

  tabGroupEls.forEach((tabGroupEl) => {
    if (tabGroupEl.dataset.tabsInit) return;
    tabGroupEl.dataset.tabsInit = 'true';
    initTabGroup(tabGroupEl);
  });
};

export default initTabs;
